module.exports = __webpack_public_path__ + "static/media/gameFitFive.ad3eb612.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameFitFive.png
// module id = 2381
// module chunks = 0